import { i18n } from "next-i18next";
import * as yup from "yup";

import { isEmailValid } from "@components/EmailInput";
import { isPhoneNumberValid } from "@components/PhoneInput";

import { OrderFields } from "../../../constants";

const newLockerFields = [OrderFields.NEW_ADDRESS_LOCKER];
const newAddressFields = [
  OrderFields.NEW_ADDRESS_STREET,
  OrderFields.NEW_ADDRESS_CITY,
  OrderFields.NEW_ADDRESS_ZIP_CODE,
];

const updateLockerFields = [OrderFields.RECEIVER_LOCKER];
const updateAddressFields = [OrderFields.RECEIVER_STREET, OrderFields.RECEIVER_CITY, OrderFields.RECEIVER_ZIP_CODE];

const isAllFieldsUndefined = (fieldValues: any[]): boolean => fieldValues.every((val) => !val);

const getConditionalRequiredFieldSchema = (conditionEmptyFields: string[]) =>
  yup.lazy(() =>
    yup.string().when(conditionEmptyFields, (...args) => {
      const fieldValues = args[0].slice(0, conditionEmptyFields.length);
      const schema = args[1];

      if (isAllFieldsUndefined(fieldValues)) {
        return schema.required(i18n?.t("order-message-field_is_required"));
      }
      return schema;
    })
  );

const getPhoneNumberFieldSchema = () =>
  yup.lazy(() =>
    yup
      .string()
      .required(i18n?.t("order-message-field_is_required"))
      .test(
        "phone-number",
        i18n?.t("common-phone_input-invalid_format") || "",
        (value?: string) => !!value && isPhoneNumberValid(value)
      )
  );

const getEmailFieldSchema = () =>
  yup.lazy(() =>
    yup
      .string()
      .optional()
      .test(
        "email",
        i18n?.t("common-email_input-invalid_format") || "",
        (value?: string) => !value || (!!value && isEmailValid(value))
      )
  );

export const getNewAddressSchema = (): yup.AnySchema =>
  yup.object({
    [OrderFields.NEW_ADDRESS_NAME]: yup
      .string()
      .required(i18n?.t("order-message-field_is_required"))
      .max(35, i18n?.t("order-message-name_exceeds_maximum_length")),
    [OrderFields.NEW_ADDRESS_PHONE]: getPhoneNumberFieldSchema(),
    [OrderFields.NEW_ADDRESS_EMAIL]: getEmailFieldSchema(),
    [OrderFields.NEW_ADDRESS_LOCKER]: getConditionalRequiredFieldSchema(newAddressFields),
    [OrderFields.NEW_ADDRESS_LOCKER_NAME]: getConditionalRequiredFieldSchema(newAddressFields),
    [OrderFields.NEW_ADDRESS_STREET]: getConditionalRequiredFieldSchema(newLockerFields),
    [OrderFields.NEW_ADDRESS_HOUSE_NO]: yup.string().optional(),
    [OrderFields.NEW_ADDRESS_FLAT_NO]: yup.string().optional(),
    [OrderFields.NEW_ADDRESS_CITY]: getConditionalRequiredFieldSchema(newLockerFields),
    [OrderFields.NEW_ADDRESS_ZIP_CODE]: getConditionalRequiredFieldSchema(newLockerFields),
  });

export const getUpdateAddressSchema = (): yup.AnySchema =>
  yup.object({
    [OrderFields.RECEIVER_NAME]: yup.string().optional().max(35, i18n?.t("order-message-name_exceeds_maximum_length")),
    [OrderFields.RECEIVER_PHONE_NUMBER]: getPhoneNumberFieldSchema(),
    [OrderFields.RECEIVER_EMAIL]: getEmailFieldSchema(),
    [OrderFields.RECEIVER_LOCKER]: getConditionalRequiredFieldSchema(updateAddressFields),
    [OrderFields.RECEIVER_STREET]: getConditionalRequiredFieldSchema(updateLockerFields),
    [OrderFields.RECEIVER_HOUSE_NO]: yup.string().optional(),
    [OrderFields.RECEIVER_FLAT_NO]: yup.string().optional(),
    [OrderFields.RECEIVER_CITY]: getConditionalRequiredFieldSchema(updateLockerFields),
    [OrderFields.RECEIVER_ZIP_CODE]: getConditionalRequiredFieldSchema(updateLockerFields),
  });
